var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{attrs:{"hidden":""}},[_vm._v("\n  websocket\n  "),_c('b-modal',{attrs:{"id":"websocketsModal","title":"System Message","ok-only":"","hide-footer":""}},[_vm._v("\n    "+_vm._s(_vm.text)+"\n  ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }